import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        emailTemplateFormOpen: false,
        uniqueDurationGridIsOpen: false,
        uniqueDurationFormIsOpen: false,
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új kezelés',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow',
            },
            {
                btn_text: '<i class="fas fa-user-edit"></i> Egyedi időtartamok orvosonként',
                event_name: "customClick",
                class: "btn btn-info my-custom-class",
                event_payload: 'openUniqueDurationCrud'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="far fa-envelope"></i>',
                title: 'E-mail sablon szerkesztése',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                event_payload: 'createEmailTemplate',
                additionalButtonVisible: 'hasEmailTemplateEditPermission'
            },
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyRow',
                additionalButtonVisible: 'hasTreatmentTypeCreatePermission'
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow',
                additionalButtonVisible: 'hasTreatmentTypeEditPermission'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow',
                additionalButtonVisible: 'hasTreatmentTypeDeletePermission'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'

            }
        ],
        headerFields: [
            {
                name: "id",
                label: "Azonosító",
                filter: {
                    type: "simple",
                },
                sort: true,
                uniqueId: true,
                formType: 'text',
                formReadOnly: true,
                formSize: 4,
                visibility: false,
                formVisible: false
            },
            {
                name: "code",
                label: "Kezelésfajta kódja",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'text',
                formSize: 3,
                visibility: true,
                formVisible: true,
                formRequired: true
            },
            {
                name: "title",
                label: "Kezelésfajta neve",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'text',
                formSize: 3,
                visibility: true,
                formVisible: true,
                formRequired: true
            },
            {
                name: "duration",
                label: "Időtartam",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'number',
                formSize: 3,
                visibility: true,
                formVisible: true,
                formRequired: true
            },
            {
                name: "deleted",
                label: "Állapot",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
                formVisible: false
            },
            {
                name: "companyId",
                label: "companyId",
                visibility: false,
                formVisible: false
            },
            {
                name: "price",
                label: "Kezelésfajta alapértelmezett ára",
                filter: {
                    type: "simple",
                },
                sort: true,
                slot_name: 'treatment_price_format',
                formType: 'number',
                formSize: 3,
                visibility: true,
                formVisible: true,
                formRequired: true
            },
            {
                name: "description",
                label: "Kezelés leírása",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'text',
                formSize: 4,
                visibility: false,
                formVisible: true
            },
            {
                name: "treatmentCategoryId",
                label: "Kategória",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getTreatmentCategories,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "treatmentCategory.text",
                filter: {
                    type: "simple",
                },
                label: "Kategória",
                visibility: true,
                formVisible: false
            },
            {
                name: "isOccupationHealth",
                label: "Foglalkozás egészségügy?",
                slot_name: "isOccupationHealth_format",
                visibility: false,
                sort: true,
                formType: 'checkbox',
                formSize: 2,
                formVisible: true
            },
            {
                name: "basic",
                label: "Alapkezelés",
                //slot_name: "isBasic_format",
                visibility: false,
                formType: 'checkbox',
                formSize: 2,
                formVisible: true
            },
            {
                name: "disableEmail",
                label: "E-mail kiküldés tiltása",
                description: "Erről a kezelésről nem küld a rendszer emlékeztető és sikeres foglalás e-mailt",
                slot_name: "disableEmail_format",
                visibility: true,
                formType: 'checkbox',
                formSize: 2,
                formVisible: true
            },
            {
                name: "organizationUnits",
                label: "Szervezeti egységek",
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.findAllOrganizationUnit,
                    formatOption: function (val) {
                        return val.organizationUnitName + " (" + val.organizationUnitId + " - " + val.companySite.siteName + ")";
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'organizationUnitName',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 12,
                visibility: false,
                formVisible: true
            },
            {
                name: "tools",
                label: "Eszközök",
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getAllInstrumentToTreatmentType,
                    formatOption: function (val) {
                        return val.name;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'name',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "stocks",
                label: "Anyagok",
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getAllStockToTreatmentType,
                    formatOption: function (val) {
                        return val.name;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'name',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "teszorCode.text",
                label: "TESZOR kód",
                visibility: true,
                formVisible: true,
                formSize: 2,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllTeszorCodes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "kaszCode",
                label: "KASZ kód",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2
            },
            {
                name: "field",
                label: " Szakterület",
                visibility: true,
                formType: "textarea",
                formVisible: true,
                formSize: 3,
            },
            {
                name: "isForPackage",
                label: "Csomagokhoz tartozik",
                visibility: true,
                formVisible: true,
                slot_name: "isForpackageFormat",
                formType: 'checkbox',
                formSize: 2
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        uniqueDurationAdditionalTableConfig: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        uniqueDurationActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class",
                event_payload: 'backToTreatmentTypeGrid'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showUniqueDurationSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új egyedi időtartam',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newUniqueDurationRow'
            }
        ],
        uniqueDurationFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToUniqueDurationGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetUniqueDurationForm'
            }
        ],
        uniqueDurationRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyUniqueDurationRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteUniqueDurationRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteUniqueDurationRow'
            }
        ],
        uniqueDurationSearchFields: [
            {
                name: "doctorId",
                label: "Orvos",
                formType: "select",
                formSize: 6,
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            },
            {
                name: "treatmentId",
                label: "Kezelés",
                formSize: 6,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllTreatmentType,
                    formatText: function (val) {
                        return val.title;
                    },
                    formatOption: function (val) {
                        return val.title;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'title',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
        ],
        uniqueDurationHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "doctorId",
                label: "Orvos",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "doctor.fullName",
                label: "Orvos",
                visibility: true,
                formVisible: false
            },
            {
                name: "treatmentId",
                label: "Kezelés",
                visibility: false,
                formVisible: true,
                formSize: 4,
                formRequired: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllTreatmentType,
                    formatText: function (val) {
                        return val.title;
                    },
                    formatOption: function (val) {
                        return val.title;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'title',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "treatmentType.title",
                label: "Kezelés",
                visibility: true,
                formVisible: false
            },
            {
                name: "duration",
                label: "Egyedi időtartam",
                visibility: true,
                formRequired: true,
                formVisible: true,
                formSize: 4,
                formType: "number"
            },

            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
